export const en = {
  common: {
    welcome: 'Welcome back',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    submit: 'Submit',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    viewAll: 'View All',
    download: 'Download',
    share: 'Share',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    send: 'Send',
    search: 'Search',
    noResults: 'No results found',
    daysLeft: 'days left',
    justNow: 'Just now',
    hoursAgo: 'h ago',
    daysAgo: 'd ago',
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    phoneNumber: 'Phone Number',
    enterPhone: 'Enter your phone number',
    phonePlaceholder: '+971 50 XXX XXXX',
    sendOtp: 'Send OTP',
    enterOtp: 'Enter OTP Code',
    otpSent: 'OTP sent to your phone',
    verify: 'Verify',
    verifying: 'Verifying...',
    resendOtp: 'Resend OTP',
    resendIn: 'Resend in',
    seconds: 'seconds',
    invalidOtp: 'Invalid OTP code',
    otpExpired: 'OTP expired. Please resend.',
    welcomeTitle: 'Welcome to',
    appName: 'Real Estate Portal',
    welcomeSubtitle: 'Sign in to access your property dashboard',
  },
  navigation: {
    home: 'Home',
    properties: 'Properties',
    payments: 'Payments',
    support: 'Support',
    more: 'More',
  },
  dashboard: {
    welcome: 'Welcome back',
    myProperties: 'My Properties',
    avgProgress: 'Avg. Progress',
    latestAnnouncement: 'Latest Announcement',
    nextPaymentDue: 'Next Payment Due',
    overallConstruction: 'Overall Construction',
    avgProgressDesc: 'Average progress across all your properties',
  },
  properties: {
    title: 'Properties',
    unitSpecifications: 'Unit Specifications',
    documents: 'Documents',
    files: 'files',
    unitId: 'Unit ID',
    floor: 'Floor',
    area: 'Area',
    project: 'Project',
    constructionProgress: 'Construction Progress',
    nextInstallment: 'Next Installment',
  },
  construction: {
    title: 'Construction Progress',
    subtitle: 'Track the building progress in real-time',
    projectProgress: 'Project Progress',
    myUnitProgress: 'My Unit Progress',
    completion: 'Completion',
    complete: 'Complete',
    milestones: 'Milestones',
    sitePhotos: 'Site Photos',
    photos: 'Photos',
    completed: 'Completed',
    expected: 'Expected',
  },
  payments: {
    title: 'Payment Ledger',
    subtitle: 'Track and manage your installments',
    totalPaid: 'Total Paid',
    pending: 'Pending',
    all: 'All',
    paid: 'Paid',
    upcoming: 'Upcoming',
    overdue: 'Overdue',
    overdueAlert: 'Overdue Payment',
    overdueAlertPlural: 'Overdue Payments',
    overdueMessage: 'Please pay now or upload payment proof to avoid penalties',
    payNow: 'Pay Now',
    uploadProof: 'Upload Proof',
    uploadPaymentProof: 'Upload Payment Proof',
    transactionRef: 'Transaction Reference',
    enterBankRef: 'Enter bank reference number',
    uploadReceipt: 'Upload Receipt',
    selectFile: 'Select file',
    submitProof: 'Submit Proof',
    payWithVisa: 'Pay with Visa',
    amountToPay: 'Amount to Pay',
    cardNumber: 'Card Number',
    cardholderName: 'Cardholder Name',
    expiryMonth: 'Expiry Month',
    expiryYear: 'Expiry Year',
    cvv: 'CVV',
    securePayment: 'Your payment is secured with 256-bit SSL encryption',
    paymentSuccessful: 'Payment Successful!',
    paymentProcessed: 'Your payment has been processed successfully.',
  },
  support: {
    title: 'Support Tickets',
    subtitle: 'Get help with your property queries',
    open: 'Open',
    resolved: 'Resolved',
    new: 'New',
    inProgress: 'In Progress',
    createTicket: 'Create New Ticket',
    category: 'Category',
    selectCategory: 'Select category',
    subject: 'Subject',
    subjectPlaceholder: 'Brief description of your issue',
    description: 'Description',
    descriptionPlaceholder: 'Provide details about your request...',
    submitTicket: 'Submit Ticket',
    ticketResolved: 'This ticket has been resolved',
    createNewTicket:
      'If you need further assistance, please create a new ticket',
    responseTime: 'Our support team typically responds within 24 hours',
    sendReply: 'Send Reply',
    typeReply: 'Type your reply...',
    categories: {
      payments: 'Payments',
      property: 'Property',
      siteVisit: 'Site Visit',
      documents: 'Documents',
      account: 'Account',
      other: 'Other',
    },
  },
  discovery: {
    title: 'Discover Projects',
    subtitle: 'Explore new investment opportunities',
    searchPlaceholder: 'Search by project or location...',
    noProjects: 'No projects found',
    interested: "I'm Interested",
    expressInterest: 'Express Interest',
    interestSubmitted: 'Interest Submitted!',
    salesContact: 'Our sales team will contact you within 24 hours.',
    fullName: 'Full Name',
    email: 'Email',
    message: 'Message (Optional)',
    messagePlaceholder: 'Any specific requirements or questions?',
    submitInterest: 'Submit Interest',
    startingFrom: 'Starting From',
    units: 'Units',
    completion: 'Completion',
  },
  referral: {
    title: 'Referral Program',
    subtitle: 'Earn rewards by referring friends & family',
    earnReward: 'Earn AED 10,000',
    rewardDesc: 'For every successful referral that closes a deal',
    totalReferrals: 'Total Referrals',
    successful: 'Successful',
    submitReferral: 'Submit a New Referral',
    referralName: 'Full Name',
    referralNamePlaceholder: "Enter referral's name",
    referralPhone: 'Phone Number',
    referralEmail: 'Email (Optional)',
    submitReferralBtn: 'Submit Referral',
    pipeline: 'Referral Pipeline',
    yourReferrals: 'Your Referrals',
    stages: {
      newLead: 'New Lead',
      contacted: 'Contacted',
      siteVisit: 'Site Visit',
      negotiation: 'Negotiation',
      dealWon: 'Deal Won',
    },
  },
  announcements: {
    important: 'Important',
    urgent: 'Urgent',
    info: 'Info',
    forQuestions: 'For questions, contact our support team',
  },
  language: {
    english: 'English',
    arabic: 'العربية',
    switchTo: 'Switch to',
  },
}

export type TranslationKeys = typeof en
